export class Body {
  loading = [];
  header = document.querySelector('header');
  async importScript(el) {
    const tagName = el.tagName.toLowerCase();
    const devMode = location.hostname === '127.0.0.1' || Shopify && Shopify.theme && Shopify.theme.name.indexOf('Development') !== -1 || Shopify.designMode;
    if (this.loading.indexOf(tagName) !== -1) return;
    this.loading.push(tagName);
    if (!customElements.get(tagName)) {
      var scriptTag = document.createElement('script');
      scriptTag.src = `${window.settings.asset_url || '/assets/'}${tagName}.js?v=${devMode ? Date.now() : window.settings.asset_revision || Date.now()}`;
      scriptTag.async = true;
      if (devMode) scriptTag.onload = () => console.info(`Loaded: ${tagName}`);
      scriptTag.onerror = () => console.warn(`Failed to load ${tagName}.`) && this.loading.splice(this.loading.indexOf(tagName));
      document.body.appendChild(scriptTag);
    }
  }
  loadScript(el) {
    if (el.hasAttribute('data-autoload')) {
      this.importScript(el);
    } else {
      const observer = new IntersectionObserver(async (entries, observer) => {
        entries.forEach(async entry => {
          if (entry.isIntersecting) {
            this.importScript(el);
            observer.disconnect();
          }
        });
      }, {
        rootMargin: '0px 0px 200% 0px'
      });
      observer.observe(el);
    }
  }

  /* JavaScript Loader */
  initJavascript() {
    document.querySelectorAll('[data-async]').forEach(el => this.loadScript(el));
    const jsObserver = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach(mutation => {
        mutation.target.querySelectorAll('[data-async]').forEach(el => this.loadScript(el));
      });
    });
    jsObserver.observe(document.querySelector('body'), {
      childList: true,
      subtree: true,
      characterData: false,
      attributes: false
    });
  }

  /* Close panels on Escape */
  initCloser() {
    window.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        document.querySelectorAll('[data-locker]').forEach(el => el.checked = false);
        document.body.classList.remove('overflow-hidden');
      }
    });
  }

  /* Scoll lock */
  scrollLock() {
    setTimeout(() => document.querySelectorAll('[data-locker]:checked').length ? document.body.classList.add('overflow-hidden') : document.body.classList.remove('overflow-hidden'), 100);
  }
  initScrollLock() {
    //window.addEventListener('input', () => Shopify.debounce(this.scrollLock()));
    window.addEventListener('click', event => {
      const isInsideTeleportDetails = event.target.closest('teleport-details');
      if (!isInsideTeleportDetails) {
        Shopify.debounce(this.scrollLock());
      }
    });
    //window.addEventListener('resize', () => Shopify.debounce(document.querySelectorAll('[data-locker]:checked').forEach(el => el.checked = false)) && this.scrollLock(), { passive: true });
  }

  /* Capture click events */
  initClicks() {
    window.addEventListener('click', event => {
      if (!event.target) return;
      switch (event.target.tagName?.toUpperCase()) {
        case 'LABEL':
          /* Close mega menus */
          var target = event.target.querySelector('input') || document.getElementById(event.target.getAttribute('for'));
          if (target && target.name.toLowerCase().indexOf('filter') === -1 && /*target.hasAttribute('hidden') || */target.classList.contains('hidden')) {
            event.preventDefault();
            event.stopPropagation();
            target.checked = !target.checked;
            event.target.dispatchEvent(new Event('input', {
              bubbles: true
            }));
            Shopify.debounce(this.scrollLock());
          }
          break;
        case 'INPUT':
          /* Close search */
          if (event.target.id == 'Search' && event.target.checked) event.target.checked = false;
          break;
        case 'BUTTON':
        case 'A':
          /* Open cart drawer */
          if (event.target.getAttribute('href')?.match(/\/cart$/) && !event.target.closest('shopping-cart')) {
            event.preventDefault();
            document.querySelector('#Cart').checked = !document.querySelector('#Cart').checked;
          } else if (event.target.getAttribute('href')?.toLowerCase().includes('#accessibility') || event.target.getAttribute('href')?.toLowerCase().includes('#a11y')) {
            event.preventDefault();
            window.interdeal.a11y.openMenu();
            return false;
          } else if ( /* Scroll to anchor */
          event.target.getAttribute('href')?.match(/^#/) && event.target.getAttribute('href') !== '#') {
            var target = document.querySelector(event.target.getAttribute('href'));
            if (target) {
              event.preventDefault();
              window.scrollTo({
                //top: target.offsetTop - this.header.clientHeight - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--spacing-2xl')),
                top: target.offsetTop - this.header?.clientHeight,
                left: 0,
                behavior: 'smooth'
              });
              //window.dispatchEvent(new Event('scroll'));
            }
          }
          break;
      }
    });
  }

  /* Register product view */
  trackRecentlyViewed() {
    Shopify = Shopify || {};
    Shopify.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
    const url = location.href.match(`/products/([^\?#]+)`);
    if (url) {
      const index = Shopify.recentlyViewed.indexOf(url[1]);
      if (index > -1) Shopify.recentlyViewed.splice(index, 1);
      Shopify.recentlyViewed.unshift(url[1]);
      Shopify.recentlyViewed = Shopify.recentlyViewed.slice(0, 8);
      localStorage.setItem('recentlyViewed', JSON.stringify(Shopify.recentlyViewed));
    }
  }

  /**
   * Set visual viewport height
   */
  visualViewport() {
    const announcementBanner = document.querySelector('[data-announcement]');
    const bannerHeight = Math.round(announcementBanner?.clientHeight ?? 0);
    const bannerRect = announcementBanner?.getBoundingClientRect();
    let visibleBannerHeight = 0;

    // Calculate combined height based on visibility
    if (bannerRect && bannerRect.bottom > 0) {
      // If banner is partially visible, count only the visible part
      visibleBannerHeight = Math.max(0, Math.min(bannerHeight, bannerRect.bottom));
    }
    document.documentElement.style.setProperty('--visual-viewport', `${window.visualViewport.height}px`);
    document.documentElement.style.setProperty('--header-height', `${document.querySelector('header')?.clientHeight - 1}px`);
    document.documentElement.style.setProperty('--header-height-full', `${Array.from(document.querySelectorAll('.shopify-section-group-header-group')).reduce((height, el) => height + el.clientHeight, 0)}px`);
    document.documentElement.style.setProperty('--announcement-height', `${document.querySelector('[data-announcement]')?.clientHeight}px`);
    document.documentElement.style.setProperty('--dynamic-header-height-full', `${Math.round((document.querySelector('header')?.clientHeight - 1 || 0) + visibleBannerHeight)}px`);
  }

  /**
   * Scroll trigger
   */
  scrollTrigger() {
    const announcement = document.querySelector('[data-announcement');
    if (announcement) {
      const observer = new IntersectionObserver(entries => {
        entries[0].isIntersecting ? document.body.classList.remove('is-scrolled') : document.body.classList.add('is-scrolled');
      });
      observer.observe(announcement);
    }
  }

  /**
   * Geolocation check
   */
  checkLocation() {
    if (sessionStorage.getItem('geolocation')) return;
    window.Geo.perform(country => {
      if (country.handle !== window.Shopify.country) {
        const trigger = document.getElementById('Location');
        if (!trigger) return;
        const modal = trigger.nextElementSibling;
        modal.querySelector('[name="country_code"]').value = country.handle;
        modal.querySelectorAll('div').forEach(div => div.textContent.replaceAll('[detected]', country.name));
        trigger.checked = true;
        sessionStorage.setItem('geolocation', true);
      }
    });
  }
  constructor() {
    this.initJavascript();
    this.initCloser();
    this.initScrollLock();
    this.checkLocation();
    this.initClicks();
    this.scrollTrigger();
    this.trackRecentlyViewed();
    this.visualViewport();
    document.addEventListener('DOMContentLoaded', () => {
      this.visualViewport();
      (window.visualViewport || window).addEventListener('resize', Shopify.debounce(this.visualViewport), {
        passive: true
      });
    });
    window.addEventListener('scroll', Shopify.debounce(this.visualViewport, 10), {
      passive: true
    });

    /* Already subscribed message */
    window.addEventListener('load', () => {
      const url = window.location.href;
      if (url.includes('form_type=customer')) {
        var id = url.split('#'),
          id = id.length > 1 ? id[id.length - 1] : 'footer';
        var form = document.querySelector(`#${id}`) || document.querySelector('footer[action^="/contact"]');
        if (form) {
          const input = form.querySelector('[type="email"]');
          if (input && input.value.length > 0) {
            const el = document.createElement('p');
            el.classList.add('mt-sm');
            el.innerText = window.strings.existing;
            form.appendChild(el);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'newsletter_signup',
              form_action: 'submit-failure',
              error_id: window.strings.existing
            });
          }
        }
      }
    });
  }
}